
// form[tabindex=0][disabled] should be focusable as the
// specification doesn't know the disabled attribute on the form element
// @specification https://www.w3.org/TR/html5/forms.html#the-form-element
export default {
  element: 'form',
  mutate: function mutate(element) {
    element.setAttribute('tabindex', 0);
    element.setAttribute('disabled', 'disabled');
  }
};
//# sourceMappingURL=focus-form-disabled.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ally.js/esm/supports/focus-form-disabled.js
// module id = 183
// module chunks = 0 1